// Mock implementation of react-native-fs for web
// This module is not fully supported on web, but we provide stubs to prevent errors

// File type constants
export const RNFSFileTypeRegular = 0
export const RNFSFileTypeDirectory = 1

// Directory paths (using browser-compatible paths)
export const DocumentDirectoryPath = "/documents"
export const CachesDirectoryPath = "/caches"
export const TemporaryDirectoryPath = "/tmp"
export const MainBundlePath = "/"
export const ExternalDirectoryPath = "/external"
export const ExternalStorageDirectoryPath = "/external-storage"
export const DownloadDirectoryPath = "/downloads"
export const PicturesDirectoryPath = "/pictures"
export const LibraryDirectoryPath = "/library"
export const ExternalCachesDirectoryPath = "/external-caches"

// Mock file operations
export const mkdir = (filepath: string, options?: any): Promise<void> => {
  console.warn("react-native-fs mkdir is not supported on web")
  return Promise.resolve()
}

export const moveFile = (filepath: string, destPath: string): Promise<void> => {
  console.warn("react-native-fs moveFile is not supported on web")
  return Promise.resolve()
}

export const copyFile = (filepath: string, destPath: string): Promise<void> => {
  console.warn("react-native-fs copyFile is not supported on web")
  return Promise.resolve()
}

export const unlink = (filepath: string): Promise<void> => {
  console.warn("react-native-fs unlink is not supported on web")
  return Promise.resolve()
}

export const exists = (filepath: string): Promise<boolean> => {
  console.warn("react-native-fs exists is not supported on web")
  return Promise.resolve(false)
}

export const readDir = (dirpath: string): Promise<any[]> => {
  console.warn("react-native-fs readDir is not supported on web")
  return Promise.resolve([])
}

export const readdir = (dirpath: string): Promise<string[]> => {
  console.warn("react-native-fs readdir is not supported on web")
  return Promise.resolve([])
}

export const stat = (filepath: string): Promise<any> => {
  console.warn("react-native-fs stat is not supported on web")
  return Promise.resolve({
    name: "",
    path: filepath,
    size: 0,
    mode: 0,
    ctime: 0,
    mtime: 0,
    originalFilepath: filepath,
    isFile: () => false,
    isDirectory: () => false,
  })
}

export const readFile = (filepath: string, encoding?: string): Promise<string> => {
  console.warn("react-native-fs readFile is not supported on web")
  return Promise.resolve("")
}

export const writeFile = (filepath: string, contents: string, encoding?: string): Promise<void> => {
  console.warn("react-native-fs writeFile is not supported on web")
  return Promise.resolve()
}

export const appendFile = (
  filepath: string,
  contents: string,
  encoding?: string,
): Promise<void> => {
  console.warn("react-native-fs appendFile is not supported on web")
  return Promise.resolve()
}

export const downloadFile = (options: {
  fromUrl: string
  toFile: string
  headers?: any
  background?: boolean
  begin?: (res: any) => void
  progress?: (res: any) => void
}): { jobId: number; promise: Promise<any> } => {
  console.warn("react-native-fs downloadFile is not supported on web - use fetch API instead")
  return {
    jobId: 0,
    promise: Promise.resolve({
      jobId: 0,
      statusCode: 200,
      bytesWritten: 0,
    }),
  }
}

export const uploadFiles = (options: any): { jobId: number; promise: Promise<any> } => {
  console.warn("react-native-fs uploadFiles is not supported on web")
  return {
    jobId: 0,
    promise: Promise.resolve({
      jobId: 0,
      statusCode: 200,
      headers: {},
      body: "",
    }),
  }
}

export const stopDownload = (jobId: number): void => {
  console.warn("react-native-fs stopDownload is not supported on web")
}

export const stopUpload = (jobId: number): void => {
  console.warn("react-native-fs stopUpload is not supported on web")
}

export const hash = (filepath: string, algorithm: string): Promise<string> => {
  console.warn("react-native-fs hash is not supported on web")
  return Promise.resolve("")
}

export const touch = (filepath: string, mtime?: Date, ctime?: Date): Promise<void> => {
  console.warn("react-native-fs touch is not supported on web")
  return Promise.resolve()
}

export const getFSInfo = (): Promise<any> => {
  console.warn("react-native-fs getFSInfo is not supported on web")
  return Promise.resolve({
    totalSpace: 0,
    freeSpace: 0,
  })
}

const RNFS = {
  RNFSFileTypeRegular,
  RNFSFileTypeDirectory,
  DocumentDirectoryPath,
  CachesDirectoryPath,
  TemporaryDirectoryPath,
  MainBundlePath,
  ExternalDirectoryPath,
  ExternalStorageDirectoryPath,
  DownloadDirectoryPath,
  PicturesDirectoryPath,
  LibraryDirectoryPath,
  ExternalCachesDirectoryPath,
  mkdir,
  moveFile,
  copyFile,
  unlink,
  exists,
  readDir,
  readdir,
  stat,
  readFile,
  writeFile,
  appendFile,
  downloadFile,
  uploadFiles,
  stopDownload,
  stopUpload,
  hash,
  touch,
  getFSInfo,
}

export default RNFS
